<template>
  <Modal :title="title" :showModal="showModal" class="history-form">
    <template v-slot:body>
      <div class="vertical-timeline vertical-timeline--animate vertical-timeline--one-column">
        <div v-for="(item, index) in data" :key="index" class="vertical-timeline-item vertical-timeline-element">
          <span class="vertical-timeline-element-icon bounce-in">
            <i class="badge badge-dot badge-dot-xl badge-success">&nbsp;</i>
          </span>
          <div class="vertical-timeline-element-content bounce-in">
            <h4 class="timeline-title">{{ item.action }}</h4>
            <p class="timeline-user"><i class="lnr-user"></i>{{ item.user }}</p>
            <div class="description">
              <div class="line-item-meta">
                <div v-if="item.description.action" class="action">
                  <label>Action:&nbsp;</label>
                  <span>{{ item.description.action }}</span>
                </div>
                <div v-if="item.description.design_name" class="design-name">
                  <label>Design:&nbsp;</label>
                  <a v-if="item.description.design_url" :href="item.description.design_url" target="_blank">{{ item.description.design_name }}</a>
                  <span v-else>{{ item.description.design_name }}</span>
                </div>
                <template v-if="item.description.attributes">
                  <div v-for="(attribute, key) in item.description.attributes" :key="key" class="meta-group size">
                    <label class="text-capitalize">{{ key }}:&nbsp;</label><span class="select-all" v-html="attribute"></span>
                  </div>
                </template>
                <template v-if="item.description.note">
                  <p class="meta-group note">
                    <label>Note: </label>
                  </p>
                  <ul>
                    <li v-for="(note, key) in item?.description?.note" :key="key" v-html="note?.replace('\n', '<br>')"></li>
                  </ul>
                </template>
              </div>
              <div v-if="item.description.status" class="line-item-status mt-2">
                <div v-if="item.description.status" class="line-item-status">
                  <label>Status:&nbsp;</label><span>{{ item.description.status_label }}</span>
                </div>
              </div>
              <div v-if="item.description.purchase_detail" class="line-item-purchase-detail mt-2">
                <div v-if="item.description.purchase_detail.prices" class="prices">
                  <label>
                    <span>Purchase Price:&nbsp;</span>
                    <p v-for="(price, priceIndex) in item.description.purchase_detail.prices" :key="priceIndex" class="price">{{ price.price }}{{ price.currency }}</p>
                  </label>
                </div>
              </div>
            </div>
            <span v-if="item.time" class="vertical-timeline-element-date" v-html="$util.timestampToDateTime(item.time, true)"></span>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    return {
      data: []
    }
  },
  computed: {
    title() {
      return 'History'
    },
    action() {
      return 'history'
    },
    storeId() {
      return this.config?.storeId
    },
    lineItemId() {
      return this.config?.item?.identify || null
    },
    getUri() {
      return `line-item/history/${this.lineItemId}`
    }
  },
  methods: {
    setUpData({ data, status }) {
      if (status == 'success') {
        this.showModal = true
        this.data = data
      }
    }
  },
  props: {
    config: Object
  }
}
</script>
